module.exports = __webpack_public_path__ + "static/account-3.5e525ec2.png";